<template>
  <div class="container">

    <!-- HEADER -->
    <div class="header row p-0 m-0">
      <div class="col-12 col-lg-6 p-0 m-0">
        <img :src="`${publicPath}img/Grupo de desplazamiento 2.jpg`" data-aos="fade-left" data-aos-duration="1000" class="img-responsive">
      </div>
      <div class="col-12 col-lg-6 text-start p-5 pb-0">
        <h1 class="text-blue mt-3">{{ $t('asistenciapersonalizada.asistencia') }}</h1>
        <p>{{ $t('asistenciapersonalizada.paciente') }}</p>
      </div>
    </div>
    <!-- end HEADER -->

    <section>

      <div class="row mt-5 px-0 px-lg-5">
        <div class="col-12 col-lg-6 px-3 px-lg-4 py-5 text-start">
          <h2>{{ $t('asistenciapersonalizada.gestion') }}</h2>
          <p class="text-black mt-4">{{ $t('asistenciapersonalizada.proceso') }}</p>
          <div class="row">
            <a :href="`${link1}`" class="text-start btnPlus" target="_blank"><img :src="`${publicPath}img/btnLink.png`" class="img-responsive">  <strong>{{ $t('literals.vermas') }}</strong></a>
          </div>
        </div>
        <div class="col-12 col-lg-6 px-0 px-lg-4 text-start">
          <img :src="`${publicPath}img/Grupo de desplazamiento 3.jpg`" data-aos="fade-down" data-aos-delay="100" data-aos-duration="1000" class="img-responsive mb-3">
        </div>
      </div>

    </section>

    <section class="p-0 p-lg-5 mx-0 mx-lg-5">
      <div class="g-0 p-0 m-0 px-0 px-lg-5">
        <h2>{{ $t('asistenciapersonalizada.asistencia_presencial') }}</h2>
        <h6 class="text-black my-3"><strong>{{ $t('asistenciapersonalizada.todos') }}</strong></h6>

        <div class="container col-12 col-lg-9 border border-light p-3 m-0 m-auto" data-aos="fade-in" data-aos-duration="1000" data-aos-id="start-counter-informe">
          <div class="row align-items-center">
            <div class="col-12 col-lg-4">
              <h2 class="p-0 m-0">
                <AnimatedNumber
                  ref='counter_visitas'
                  :startAmount='0'
                  :endAmount='1316524'
                  :duration='2'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='0'
                  :autoinit='true'
                  @finished='counterFinished'
              />
                </h2>
              <p class="textSmall">{{ $t('asistenciapersonalizada.visitas') }}</p>
            </div>
            <div class="col-12 col-lg-4">
              <h2 class="p-0 m-0">
                <AnimatedNumber
                    ref='counter_sesiones'
                    :startAmount='0'
                    :endAmount='413241'
                    :duration='2'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                /></h2>
              <p class="textSmall">{{ $t('asistenciapersonalizada.sesiones') }}</p>
            </div>
            <div class="col-12 col-lg-4">
              <h2 class="p-0 m-0">
                <AnimatedNumber
                    ref='counter_ingresos'
                    :startAmount='0'
                    :endAmount='5665'
                    :duration='2'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                />
                </h2>
              <p class="textSmall">{{ $t('asistenciapersonalizada.ingresos') }}</p>
            </div>
          </div>
          <div class="row align-items-center">
            <div class="col-12 col-lg-2 border-end border-light py-3"></div>
            <div class="col-12 col-lg-2"></div>
            <div class="col-12 col-lg-2 border-end border-light py-3"></div>
            <div class="col-12 col-lg-2"></div>
            <div class="col-12 col-lg-2 border-end border-light py-3"></div>
            <div class="col-12 col-lg-2"></div>
          </div>
          <div class="row align-items-center">
            <div class="col-12 col-lg-4">
              <h2 class="p-0 m-0">+<AnimatedNumber
                  ref='counter_respecto_1'
                  :startAmount='0'
                  :endAmount='31.7'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='1'
                  :autoinit='true'
                  @finished='counterFinished'
              />%</h2>
              <p class="textSmall">{{ $t('asistenciapersonalizada.respecto') }}</p>
            </div>
            <div class="col-12 col-lg-4">
              <h2 class="p-0 m-0">+<AnimatedNumber
                  ref='counter_respecto_2'
                  :startAmount='0'
                  :endAmount='33.7'
                  :duration='2'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='1'
                  :autoinit='true'
                  @finished='counterFinished'
              />%</h2>
              <p class="textSmall">{{ $t('asistenciapersonalizada.respecto') }}</p>
            </div>
            <div class="col-12 col-lg-4">
              <h2 class="p-0 m-0">+<AnimatedNumber
                  ref='counter_respecto_3'
                  :startAmount='0'
                  :endAmount='19.5'
                  :duration='2'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='1'
                  :autoinit='true'
                  @finished='counterFinished'
              />%</h2>
              <p class="textSmall">{{ $t('asistenciapersonalizada.respecto') }}</p>
            </div>
          </div>
        </div>
        <hr class="filigrana">

      </div>
    </section>

    <section class="p-0 px-lg-5 py-lg-0 mx-0 mx-lg-5">
      <div class="row">
        <h2 class="mb-3">{{ $t('asistenciapersonalizada.telemedicina') }}</h2>
        <h6 class="text-black mt-3 mb-5"><strong>{{ $t('asistenciapersonalizada.clinica') }}</strong></h6>
        <div class="col-12 col-lg-6 text-start pe-0 pe-lg-5 pb-5">
          <p class="text-black">{{ $t('asistenciapersonalizada.modelo') }}</p>
            <ul>
              <li class="text-black" v-html="$t('asistenciapersonalizada.movilidad')"></li>
              <li class="text-black" v-html="$t('asistenciapersonalizada.entre_centros')"></li>
              <li class="text-black" v-html="$t('asistenciapersonalizada.otros_centros')"></li>
            </ul>

          <div class="row">
            <a :href="`${link2}`" class="text-start btnPlus" target="_blank"><img :src="`${publicPath}img/btnLink.png`" class="img-responsive">  <strong>{{ $t('literals.vermas') }}</strong></a>
          </div>

        </div>
        <div class="col-12 col-lg-6">
          <h3>{{ $t('asistenciapersonalizada.clinica_online') }}</h3>
          <div class="container border border-light p-3 m-0" data-aos="fade-in" data-aos-duration="1000" data-aos-id="start-counter-cuidado">
            <div class="row align-items-top">
              <div class="col-12 col-lg-5 pt-2">
                <h2 class="p-0 m-0"><AnimatedNumber
                    ref='counter_consultas'
                    :startAmount='0'
                    :endAmount='15107'
                    :duration='2'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                /></h2>
                <p class="textSmall">{{ $t('asistenciapersonalizada.consultas') }}</p>
                <div class="col-6 py-3 border-end border-light"></div>
                <h2 class="p-0 mt-2">+<AnimatedNumber
                    ref='counter_respecto_4'
                    :startAmount='0'
                    :endAmount='8.1'
                    :duration='3'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='1'
                    :autoinit='true'
                    @finished='counterFinished'
                />%</h2>
                <p class="textSmall">{{ $t('asistenciapersonalizada.respecto') }}</p>
              </div>
              <div class="col-12 col-lg-2">
                <img :src="`${publicPath}img/Grupo 1700.png`" data-aos="fade-down" data-aos-duration="1000" class="img-responsive">
              </div>
              <div class="col-12 col-lg-5 pt-5">
                <h2 class="p-0 m-0"><AnimatedNumber
                    ref='counter_consultas_atendidas'
                    :startAmount='0'
                    :endAmount='72343'
                    :duration='2'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                /></h2>
                <p class="textSmall">{{ $t('asistenciapersonalizada.consultas_atendidas') }}</p>
              </div>
            </div>
          </div>
          <hr class="filigrana mb-5 mb-lg-0">
        </div>
      </div>
    </section>


    <section class="p-0 p-lg-5 mx-0 mx-lg-5">
      <div class="container bg-blau">
        <div class="row">
          <div class="col-12 col-lg-6 px-5 pt-3 pb-5 pb-lg-0 text-start justify-content-center">
            <img :src="`${publicPath}img/Grupo 1703.png`" class="img-responsive mb-3">
            <h6 class="myriadPro"><strong>{{ $t('asistenciapersonalizada.seguimos') }}</strong></h6>
            <p class="textSmall text-black" v-html="$t('asistenciapersonalizada.juan')"></p>
            <div class="row">
              <a href="https://youtu.be/Na_urjZJkNE" target="_blank" class="btnPlus"><img :src="`${publicPath}img/btnLink.png`" class="img-responsive">  <strong>{{ $t('literals.vervideo') }}</strong></a>
            </div>
          </div>
          <div class="col-12 col-lg-6 p-0 m-0">
            <a href="https://youtu.be/Na_urjZJkNE" target="_blank"><img :src="`${publicPath}img/Grupo-de-desplazamiento-4.jpg`" data-aos="fade-left" data-aos-delay="200" data-aos-duration="1000" class="img-responsive"></a>
          </div>
        </div>
      </div>
    </section>

    <section class="p-0 px-lg-5 py-5 py-lg-0 mx-0 mx-lg-5">
      <div class="row">
        <div class="col-12 col-lg-6 text-start pe-0 pe-lg-5" data-aos="fade-in" data-aos-delay="200" data-aos-duration="1000" data-aos-id="start-counter-equipo">
          <h6><strong>{{ $t('asistenciapersonalizada.psico') }}</strong></h6>
          <p class="text-black">{{ $t('asistenciapersonalizada.desarrollo') }}</p>
        </div>
        <div class="col-12 col-lg-6">
          <div class="container border border-light p-3 m-0">
            <div class="row align-items-top">
              <div class="col-12 col-lg-5 pt-2">
                <h2 class="p-0 m-0"><AnimatedNumber
                    ref='counter_pacientes'
                    :startAmount='0'
                    :endAmount='2796'
                    :duration='2'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                /></h2>
                <p class="textSmall">{{ $t('asistenciapersonalizada.pacientes_atendidos') }}</p>
                <div class="col-6 py-3 border-end border-light"></div>
                <h2 class="p-0 mt-2">+<AnimatedNumber
                    ref='counter_respecto_5'
                    :startAmount='0'
                    :endAmount='26.3'
                    :duration='3'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='1'
                    :autoinit='true'
                    @finished='counterFinished'
                />%</h2>
                <p class="textSmall">{{ $t('asistenciapersonalizada.respecto') }}</p>
              </div>
              <div class="col-12 col-lg-2">
                <img :src="`${publicPath}img/Grupo 1720.png`" data-aos="fade-down" data-aos-duration="1000" class="img-responsive">
              </div>
              <div class="col-12 col-lg-5 pt-2">
                <h2 class="p-0 m-0"><AnimatedNumber
                    ref='counter_consultas_realizadas'
                    :startAmount='0'
                    :endAmount='4992'
                    :duration='3'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                /></h2>
                <p class="textSmall">{{ $t('asistenciapersonalizada.realizadas') }}</p>
                <div class="col-6 py-3 border-end border-light"></div>
                <h2 class="p-0 mt-2">+<AnimatedNumber
                    ref='counter_respecto_6'
                    :startAmount='0'
                    :endAmount='33.3'
                    :duration='3'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='1'
                    :autoinit='true'
                    @finished='counterFinished'
                />%</h2>
                <p class="textSmall">{{ $t('asistenciapersonalizada.respecto') }}</p>
              </div>
            </div>
          </div>
          <hr class="filigrana mb-0">
        </div>
      </div>
    </section>

    <section class="p-0 p-lg-5 mx-0 mx-lg-5">
      <div class="container bg-blau">
        <div class="row">
          <div class="col-12 col-lg-6 p-5 pt-3 pb-5 pb-lg-0 text-start justify-content-center">
            <img :src="`${publicPath}img/Grupo 1703.png`" class="img-responsive mb-3">
            <h6 class="myriadPro"><strong>{{ $t('asistenciapersonalizada.desarrolla') }}</strong></h6>
            <p class="textSmall text-black" v-html="$t('asistenciapersonalizada.frederic')"></p>
            <div class="row">
              <a href="https://youtu.be/HxoevyD6Utw" target="_blank" class="btnPlus"><img :src="`${publicPath}img/btnLink.png`" class="img-responsive">  <strong>{{ $t('literals.vervideo') }}</strong></a>
            </div>
          </div>
          <div class="col-12 col-lg-6 p-0 m-0">
            <a href="https://youtu.be/HxoevyD6Utw" target="_blank"><img :src="`${publicPath}img/Grupo-de-desplazamiento-7.jpg`" data-aos="fade-left" data-aos-delay="200" data-aos-duration="1000" class="img-responsive"></a>
          </div>
        </div>
      </div>
    </section>

    <section class="p-0 p-lg-5 py-5 py-lg-0 mx-0 mx-lg-5">
      <div class="g-0 p-0 m-0 px-0 px-lg-5">
        <h2>{{ $t('asistenciapersonalizada.canales') }}</h2>
        <div class="row align-items-top mb-5">
          <div class="col-12 col-lg-4 text-center px-4">
            <img :src="`${publicPath}img/zonaPrivada.jpg`" data-aos="fade-right" data-aos-delay="100" data-aos-duration="1000" class="img-responsive my-4">
            <h4><strong>{{ $t('asistenciapersonalizada.privada') }}</strong></h4>
            <p class="text-black">{{ $t('asistenciapersonalizada.el_acceso') }}</p>
            <div class="row">
              <a href="https://youtu.be/YDnhgFkNg48" class="btnPlus" target="_blank"><img :src="`${publicPath}img/btnLink.png`" class="img-responsive">  <strong>{{ $t('literals.vermas') }}</strong></a>
            </div>
          </div>
          <div class="col-12 col-lg-4 text-center px-4">
            <img :src="`${publicPath}img/eConsulta.jpg`" data-aos="fade-up" data-aos-duration="1000" class="img-responsive my-4">
            <h4><strong>{{ $t('asistenciapersonalizada.econsulta') }}</strong></h4>
            <p class="text-black">{{ $t('asistenciapersonalizada.uno_de_los') }}</p>
          </div>
          <div class="col-12 col-lg-4 text-center px-4">
            <img :src="`${publicPath}img/lineaUniversal.jpg`" data-aos="fade-left" data-aos-delay="100" data-aos-duration="1000" class="img-responsive my-4">
            <h4><strong>{{ $t('asistenciapersonalizada.linea') }}</strong></h4>
            <p class="text-black">{{ $t('asistenciapersonalizada.teleasistencia') }}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="p-0 p-lg-5 mx-0 mx-lg-5">
      <div class="g-0 p-0 m-0 px-0 px-lg-5" data-aos="fade-in" data-aos-delay="200" data-aos-duration="1000" data-aos-id="start-counter-pacientes">
        <h2>{{ $t('asistenciapersonalizada.elevada') }}</h2>
        <h6 class="text-black my-3"><strong>{{ $t('asistenciapersonalizada.mejora') }}</strong></h6>

        <div class="container col-9 border border-light p-3 m-0 m-auto">
          <div class="row align-items-center">
            <div class="col-9 m-auto">
              <h1 class="p-0 m-0"><AnimatedNumber
                  ref='counter_puntos'
                  :startAmount='0'
                  :endAmount='7.75'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='2'
                  :autoinit='true'
                  @finished='counterFinished'
              /></h1>
              <p class="textSmall text-black">{{ $t('asistenciapersonalizada.puntos') }}</p>
              <p class="text-black" v-html="$t('asistenciapersonalizada.destaca')">
              </p>
            </div>
          </div>
        </div>
        <hr class="filigrana">

      </div>
    </section>

    <section class="p-0 px-lg-5 py-lg-0 mx-0 mx-lg-5">
      <div class="row">
        <h2 class="mb-3">{{ $t('asistenciapersonalizada.inversion') }}</h2>
        <div class="col-12 col-lg-6 text-start pe-5">
          <p class="text-black" v-html="$t('asistenciapersonalizada.tras')">
          </p>
        </div>
        <div class="col-12 col-lg-6" data-aos="fade-in" data-aos-delay="200" data-aos-duration="1000" data-aos-id="start-counter-inversiones">
          <div class="container border border-light p-3 m-0">
            <div class="row align-items-top pt-5 pb-3">
              <div class="col-12 col-lg-5 pt-2">
                <h2 class="p-0 m-0"><AnimatedNumber
                    ref='counter_nuevas_inversiones'
                    :startAmount='0'
                    :endAmount='3.2'
                    :duration='3'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='1'
                    :autoinit='true'
                    @finished='counterFinished'
                /> M€</h2>
                <p class="textSmall">{{ $t('asistenciapersonalizada.destinados_nuevas') }}</p>
              </div>
              <div class="col-12 col-lg-2">
                <img :src="`${publicPath}img/Grupo 1790.png`" data-aos="fade-down" data-aos-duration="1000" class="img-responsive">
              </div>
              <div class="col-12 col-lg-5 pt-2">
                <h2 class="p-0 m-0"><AnimatedNumber
                    ref='counter_reformas'
                    :startAmount='0'
                    :endAmount='2.2'
                    :duration='3'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='1'
                    :autoinit='true'
                    @finished='counterFinished'
                /> M€</h2>
                <p class="textSmall">{{ $t('asistenciapersonalizada.destinados_reformas') }}</p>
              </div>
            </div>
          </div>
          <hr class="filigrana mb-0">
        </div>

      </div>
    </section>
  </div>

  <div class="container-fluid p-0 m-0 mt-5 g-0">
    <section class="p-0 m-0 g-0">
      <div class="visor m-0 p-0 g-0">

        <div class="row filaA">
          <div class="col img-home">
            <img :src="`${publicPath}img/Grupo de desplazamiento 31.jpg`" data-aos-delay="100" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/Grupo de desplazamiento 26.jpg`" data-aos-delay="200" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/Grupo de desplazamiento 28.jpg`" data-aos-delay="300" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/Grupo de desplazamiento 29.jpg`" data-aos-delay="400" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/Grupo de desplazamiento 30.jpg`" data-aos-delay="500" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/Grupo de desplazamiento 31.jpg`" data-aos-delay="600" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
        </div>

      </div>
        <div class="row g-0 mt-3">
          <a href="https://youtu.be/Nfk-WX5mbWo" class="text-center btnPlus" target="_blank"><img :src="`${publicPath}img/btnLink.png`" class="img-responsive"> <strong>{{ $t('literals.vervideo_malaga') }}</strong></a>
        </div>
    </section>
  </div>
  <div class="container">

  <section class="p-0 p-lg-5 mx-0 mx-lg-5">
      <div class="container bg-blau p-3 m-0 mt-5 mt-lg-0 px-lg-5 py-lg-5">
        <h5 class="mb-4">{{ $t('literals.contribucion_a_los_ods') }}</h5>
        <div class="row justify-content-center">
          <div class="col-3 col-lg-1 p-0 m-2">
            <img :src="`${publicPath}img/${locale}ODS03.png`" data-aos="fade-left" data-aos-delay="100" data-aos-duration="1000" class="img-responsive">
          </div>
          <div class="col-3 col-lg-1 p-0 m-2">
            <img :src="`${publicPath}img/${locale}ODS08.png`" data-aos="fade-left" data-aos-delay="200" data-aos-duration="1000" class="img-responsive">
          </div>
          <div class="col-3 col-lg-1 p-0 m-2">
            <img :src="`${publicPath}img/${locale}ODS09.png`" data-aos="fade-left" data-aos-delay="300" data-aos-duration="1000" class="img-responsive">
          </div>
          <div class="col-3 col-lg-1 p-0 m-2">
            <img :src="`${publicPath}img/${locale}ODS10.png`" data-aos="fade-left" data-aos-delay="400" data-aos-duration="1000" class="img-responsive">
          </div>
          <div class="col-3 col-lg-1 p-0 m-2">
            <img :src="`${publicPath}img/${locale}ODS17.png`" data-aos="fade-left" data-aos-delay="500" data-aos-duration="1000" class="img-responsive">
          </div>
        </div>
      </div>
    </section>


    <!-- NAVEGACIÓ PRE-FOOTER -->
    <hr>
    <div class="row p-0 g-0 mb-3">
      <div class="col-6 p-0 m-0 pb-3 text-start">
        <localized-link class="footerLink" to="/nuestra-actuacion-en-2021/2021-en-resumen"><img :src="`${publicPath}img/arrowLeft.png`" class="img-responsive arrowsFooter"> {{ $t("nav.2021-en-resumen") }}</localized-link>
      </div>
      <div class="col-6 p-0 m-0 pb-3 text-end textSmall">
        <localized-link class="footerLink" to="/nuestra-actuacion-en-2021/acciones-de-prevencion">{{ $t("nav.acciones-de-prevencion") }} <img :src="`${publicPath}img/arrowRight.png`" class="img-responsive arrowsFooter"></localized-link>
      </div>
    </div>

  </div>
</template>

<script>
import AnimatedNumber from "vue3-autocounter";

export default {
  components: {
    AnimatedNumber,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      separator: '.',
      decimal_separator: ',',
      link1: 'https://www.mutuauniversal.net/es/servicios/modelo-asistencial/modelo-de-gestion-centralizada-por-procesos-y-de-calidad/',
      link2:  'https://www.mutuauniversal.net/es/servicios/modelo-asistencial/clinica-online/',
      locale:this.$i18n.locale
    }
  },
  mounted() {
    document.addEventListener('aos:in:start-counter-informe', this.startCounter);
    document.addEventListener('aos:in:start-counter-cuidado', this.startCounterCuidado);
    document.addEventListener('aos:in:start-counter-equipo', this.startCounterEquipo);
    document.addEventListener('aos:in:start-counter-pacientes', this.startCounterPacientes);
    document.addEventListener('aos:in:start-counter-inversiones', this.startCounterInversiones);
    if(this.$i18n.locale=="en"){
      this.separator = ',';
      this.decimal_separator = '.';
    } else {
      this.separator = '.';
      this.decimal_separator = ',';
    }

    if(this.$i18n.locale=="ca"){
      this.link1 = 'https://www.mutuauniversal.net/ca/servicios/modelo-asistencial/modelo-de-gestion-centralizada-por-procesos-y-de-calidad/';
      this.link2 = 'https://www.mutuauniversal.net/ca/servicios/modelo-asistencial/clinica-online/index.html';
    }

    if(this.$i18n.locale=="en"){
      this.link1 = 'https://www.mutuauniversal.net/en/servicios/modelo-asistencial/modelo-de-gestion-centralizada-por-procesos-y-de-calidad/index.html';
      this.link2 = 'https://www.mutuauniversal.net/en/servicios/modelo-asistencial/clinica-online/index.html';
    }

    if(this.$i18n.locale=="ga"){
      this.link1 = 'https://www.mutuauniversal.net/gl/servicios/modelo-asistencial/modelo-de-gestion-centralizada-por-procesos-y-de-calidad/index.html';
      this.link2 = 'https://www.mutuauniversal.net/gl/servicios/modelo-asistencial/clinica-online/index.html';
    }

    if(this.$i18n.locale=="eu"){
      this.link1 = 'https://www.mutuauniversal.net/eu/servicios/modelo-asistencial/modelo-de-gestion-centralizada-por-procesos-y-de-calidad/index.html';
      this.link2 = 'https://www.mutuauniversal.net/eu/servicios/modelo-asistencial/clinica-online/index.html';
    }
  },
  methods: {
    startCounter() {
      if (this.$refs.counter_visitas != null) {
        this.$refs.counter_visitas.start();
      }
      if (this.$refs.counter_sesiones != null) {
        this.$refs.counter_sesiones.start();
      }
      if (this.$refs.counter_ingresos != null) {
        this.$refs.counter_ingresos.start();
      }
      if (this.$refs.counter_respecto_1 != null) {
        this.$refs.counter_respecto_1.start();
      }
      if (this.$refs.counter_respecto_2 != null) {
        this.$refs.counter_respecto_2.start();
      }
      if (this.$refs.counter_respecto_3 != null) {
        this.$refs.counter_respecto_3.start();
      }
    },
    startCounterCuidado() {
      if (this.$refs.counter_consultas != null) {
        this.$refs.counter_consultas.start();
      }
      if (this.$refs.counter_respecto_4 != null) {
        this.$refs.counter_respecto_4.start();
      }
      if (this.$refs.counter_consultas_atendidas != null) {
        this.$refs.counter_consultas_atendidas.start();
      }
    },
    startCounterEquipo() {
      if (this.$refs.counter_pacientes != null) {
        this.$refs.counter_pacientes.start();
      }
      if (this.$refs.counter_respecto_5 != null) {
        this.$refs.counter_respecto_5.start();
      }
      if (this.$refs.counter_consultas_realizadas != null) {
        this.$refs.counter_consultas_realizadas.start();
      }
      if (this.$refs.counter_respecto_6 != null) {
        this.$refs.counter_respecto_6.start();
      }
    },
    startCounterPacientes() {
      if (this.$refs.counter_puntos != null) {
        this.$refs.counter_puntos.start();
      }
    },
    startCounterInversiones() {
      if (this.$refs.counter_nuevas_inversiones != null) {
        this.$refs.counter_nuevas_inversiones.start();
      }
      if (this.$refs.counter_reformas != null) {
        this.$refs.counter_reformas.start();
      }
    }
  }
}
</script>
